import { render, staticRenderFns } from "./TheLegend.vue?vue&type=template&id=8406d654&scoped=true&"
import script from "./TheLegend.vue?vue&type=script&lang=js&"
export * from "./TheLegend.vue?vue&type=script&lang=js&"
import style0 from "./TheLegend.vue?vue&type=style&index=0&id=8406d654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8406d654",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VSpacer,VSubheader,VTooltip})
